import React from "react";
import { HOME_TYPE } from "@/components/PageHome/api/interface";
import { COMPONENT_TYPES } from "@/helpers/constants";
import NavBar from "@/components/Header/NavBar";
import NewMomFirstFold from "@/components/PageHome/components/FirstFold/NewMom";
import PregnancyFirstFold from "@/components/PageHome/components/FirstFold/Pregnancy";
import OnboardingSection from "@/components/PageHome/components/OnboardingSection";
import VideoSlider from "@/components/PageHome/components/VideoSlider";
import SpecialistCareTeamMobile from "@/components/SpecialistCareTeamMobile";
import SpecialistCareTeamWeb from "@/components/SpecialistCareTeamWeb";
import PreconceptionFirstFold from "src/components/PageHome/components/FirstFold/Preconception";
import Discover from "@/components/PageHome/components/Discover";
import Article from "@/components/PageHome/components/Article";
import Shop from "@/components/PageHome/components/Shop";
import FAQ from "@/components/FAQ";
import ArticleAyurveda from "@/components/PageHome/components/ArticleAyurveda";
import Banner from "@/components/PageHome/components/Banner";
import routes from "@/helpers/router";
import ShoppingComponent from "@/components/ShoppingComponent";
import DoctorsWidget from "@/components/DoctorsWidget";
import DiagnosticsWidget from "@/components/DiagnosticsWidget";
import VideosComponent from "@/components/VideosComponent";

interface ComponentMappingProps {
  data: any;
  homeType?: `${HOME_TYPE}`;
  extras?: { [key: string]: any };
}

const componentMapping = (props: ComponentMappingProps): React.ReactElement => {
  const { data, homeType = undefined, extras = {} } = props;
  const {
    userAgent,
    registerRef,
    elementRefs,
    deregisterRef,
    userOnBoarded,
    productInfo,
    currentSpeciality,
    doctors,
    assetPosition,
    firstFoldData,
    diagnostics,
  } = extras;
  const type = data.ComponentType;

  const category = {
    PreconceptionHome: "preconception",
    PregnancyHome: "pregnancy",
    MotherHome: "newborn-and-infant",
    BirthHome: "pregnancy",
    Home: "",
  };

  switch (type) {
    case COMPONENT_TYPES.NavBar:
      return <NavBar navBarData={data} userOnBoarded={userOnBoarded} userAgent={userAgent} pathname={routes.home} />;
    case COMPONENT_TYPES.VideoSlider:
      return (
        <div className="spacingBetweenSections">
          <VideoSlider sliderList={data?.SliderList} refs={elementRefs} />
        </div>
      );
    case COMPONENT_TYPES.OnboardingSection:
      return (
        <OnboardingSection
          data={data}
          registerRef={registerRef}
          deregisterRef={deregisterRef}
          assetPosition={assetPosition}
          userAgent={userAgent}
        />
      );
    case COMPONENT_TYPES.CareTeam:
      if (userAgent.isDesktop) {
        return <SpecialistCareTeamWeb data={data} />;
      }

      return <SpecialistCareTeamMobile data={data} />;
    case COMPONENT_TYPES.FirstFold:
      if (homeType === HOME_TYPE.PRECONCEPTION) {
        return <PreconceptionFirstFold data={data} userAgent={userAgent} />;
      }

      if (homeType === HOME_TYPE.NEW_MOM) {
        return <NewMomFirstFold data={data} />;
      }

      return <PregnancyFirstFold data={data} type={homeType} />;
    case COMPONENT_TYPES.Discover:
      return <Discover data={data} userAgent={userAgent} assetPosition={assetPosition} />;
    case COMPONENT_TYPES.QuickReads:
    case COMPONENT_TYPES.DynamicArticles:
      return (
        <Article
          data={data}
          userAgent={userAgent}
          assetPosition={assetPosition}
          pageCategory={category[homeType]}
          firstFoldData={firstFoldData}
        />
      );
    case COMPONENT_TYPES.VidCatSli:
    case COMPONENT_TYPES.DynamicVideos:
      return (
        <VideosComponent
          data={data}
          userAgent={userAgent}
          assetPosition={assetPosition}
          pageCategory={category[homeType]}
        />
      );
    case COMPONENT_TYPES.Shop:
      return (
        <div className="spacingBetweenSections">
          <Shop data={data} userAgent={userAgent} assetPosition={assetPosition} />
        </div>
      );
    case COMPONENT_TYPES.DoctorConsult:
      return (
        <DoctorsWidget
          data={data}
          userAgent={userAgent}
          currentSpeciality={currentSpeciality}
          doctors={doctors}
          utm_medium="home-page"
        />
      );
    case COMPONENT_TYPES.LabTest:
      return (
        <div className="spacingBetweenSections">
          <DiagnosticsWidget data={data} userAgent={userAgent} diagnostics={diagnostics} utm_medium="home-page" />
        </div>
      );
    case COMPONENT_TYPES.FAQ:
    case COMPONENT_TYPES.FAQWithTitle:
      return <FAQ data={data} />;
    case COMPONENT_TYPES.ArticlesByTag:
      return (
        <ArticleAyurveda
          category={category[homeType]}
          articles={data?.articles}
          Tag={data?.Tag}
          Title={data?.Title}
          userAgent={userAgent}
          assetPosition={assetPosition}
        />
      );
    case COMPONENT_TYPES.Banner:
      return (
        <div className="spacingBetweenSections">
          <Banner data={data} userAgent={extras?.userAgent} assetPosition={assetPosition} />
        </div>
      );
    case COMPONENT_TYPES.ShopByCatSlider:
      return (
        <ShoppingComponent
          data={data}
          productInfo={productInfo}
          extras={extras}
          isHomePage
          assetPosition={assetPosition}
          userOnBoarded={userOnBoarded}
          userAgent={userAgent}
        />
      );
    default:
      return null;
  }
};

export default componentMapping;
